var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg board"},[_c('div',{staticClass:"course-table m-auto"},[_c('iframe',{staticClass:"w-100",staticStyle:{"overflow-y":"scroll","overflow-x":"hidden","height":"1000px"},attrs:{"src":_vm.link,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }